export enum PoliticalUnitType {
  Unknown = 0,
  Department = 1,
  DoSi = 2,
  Island = 3,
  Parish = 4,
  Province = 5,
  State = 6,
}
